module.exports = __webpack_public_path__ + "static/media/logo.2ee03f76.svg";